<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Icon"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7071 6.48039C20.0976 6.87092 20.0976 7.50408 19.7071 7.89461L10.0821 17.5196C9.69158 17.9101 9.05842 17.9101 8.66789 17.5196L4.29289 13.1446C3.90237 12.7541 3.90237 12.1209 4.29289 11.7304C4.68342 11.3399 5.31658 11.3399 5.70711 11.7304L9.375 15.3983L18.2929 6.48039C18.6834 6.08987 19.3166 6.08987 19.7071 6.48039Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
